<template>
  <div>
    <v-dialog
      v-model="modalSend"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      persistent
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="$store.dispatch('agendDate/modalSend', false)" :disabled="loading">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title
            >Agendar cita</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="$store.dispatch('agendDate/modalSend', false)" :disabled="loading"> Cerrar </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-row>
          <v-col cols="12" class="">
            <v-card
              color="transparent"
              flat
              :class="[$vuetify.breakpoint.mdAndUp ? 'py-4 mx-12' : '']"
              tile
            >
              <v-card-title class="d-flex flex-column justify-start align-start">
                <h2
                  class="title word-wrap primary--text"
                  :class="[$vuetify.breakpoint.mdAndUp ? '' : 'px-2']"
                >Puedes solicitar una cita previa para conocer nuestras instalaciones y programas utilizando el siguiente calendario.</h2>
                <h5
                  class="instructions word-wrap mt-4"
                  :class="[$vuetify.breakpoint.mdAndUp ? '' : 'px-4']"
                >1.- Selecciona el día y la hora en la quieras reunirte con nostros.</h5>
                <h5
                  class="instructions word-wrap mt-4"
                  :class="[$vuetify.breakpoint.mdAndUp ? '' : 'px-4']"
                >2.- Deja tus datos para ponernos en contacto y agendarte.</h5>
                <h5
                  class="instructions word-wrap mt-4"
                  :class="[$vuetify.breakpoint.mdAndUp ? '' : 'px-4']"
                >3.- Recibirás un correo confirmando tu cita.</h5>
                <h5
                  class="instructions word-wrap mt-4"
                  :class="[$vuetify.breakpoint.mdAndUp ? '' : 'px-4']"
                >
                  4.- Si finalmente no puedes asistir a la cita, te solicitamos de favor te pongas en contacto con nosotros a través del email
                  <b>informes@uva.edu.mx</b> o puedes llamarnos al
                  <b>01 800 832 3245</b>.
                </h5>
              </v-card-title>
              <v-layout
                :row="$vuetify.breakpoint.mdAndUp"
                class="mx-0 mt-3"
                :column="$vuetify.breakpoint.smAndDown"
              >
                <v-flex xs12 :class="[$vuetify.breakpoint.mdAndUp ? 'px-12 ' : 'pa-2']">
                  <v-card-text>
                    <v-row class="text-center">
                      <v-col cols="12" lg="12" sm="12" md="12" class="pl-6">
                        <h3 class="primary--text">Escoge la fecha para tu cita:*</h3>
                        <v-date-picker
                          :allowed-dates="allowedDates"
                          :min="today"
                          v-model="picker"
                          color="#8E0D2C"
                          class="mt-5"
                          locale="es"
                          :width="$vuetify.breakpoint.lgAndUp ? '600':'auto'"
                        ></v-date-picker>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" lg="12" sm="12" md="12" class="pl-6">
                        <h3 class="primary--text">Selecciona un horario:*</h3>
                        <v-select
                          class="mt-8 mb-4"
                          :items="horarios"
                          label="HORARIO"
                          hide-details
                          outlined
                          v-model="information.horarios"
                        ></v-select>
                        <v-select
                          class="mt-8 mb-4"
                          :items="cities"
                          label="EN EL PLANTEL"
                          hide-details
                          outlined
                          v-model="campusSelected"
                          item-text="name"
                          item-value="id"
                        >
                          <option @click="changeCity(campus)" :value="campus"></option>
                        </v-select>
                        <h3 class="primary--text">Escoge el nivel de tu interés:*</h3>
                        <v-select
                          class="mt-8 mb-4"
                          :items="inscriptionOptions"
                          item-text="text"
                          item-value="item"
                          item-disabled="isDisabled"
                          text="isDisabled"
                          label="EN EL NIVEL DE INTERÉS"
                          hide-details
                          outlined
                          v-model="information.carrer"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" lg="12" sm="12" md="12" class="pl-6">
                        <h3 class="primary--text">Rellena con tu información:*</h3>
                      </v-col>
                      <v-col cols="12" lg="6" sm="12" md="6">
                        <v-text-field
                          class="mb-5"
                          label="PRIMER NOMBRE*"
                          placeholder="Juan"
                          v-model="information.name_first"
                          type="text"
                          id="name_first"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6" sm="12" md="6">
                        <v-text-field
                          class="mb-5"
                          label="SEGUNDO NOMBRE"
                          placeholder="Luis"
                          v-model="information.name_second"
                          type="text"
                          id="name_second"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6" sm="12" md="6">
                        <v-text-field
                          class="mb-5"
                          label="APELLIDO PATERNO*"
                          placeholder="López"
                          v-model="information.last_name"
                          type="text"
                          id="lastname"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6" sm="12" md="6">
                        <v-text-field
                          class="mb-5"
                          label="APELLIDO MATERNO*"
                          placeholder="Garcia"
                          v-model="information.mother_last_name"
                          type="text"
                          id="lastname"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6" sm="12" md="6">
                        <v-text-field
                          class="mt-5"
                          label="CORREO ELECTRÓNICO*"
                          v-model="information.email"
                          placeholder="correo@ejemplo.com"
                          type="email"
                          id="email"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6" sm="12" md="6">
                        <v-text-field
                          class="mt-5"
                          label="NÚMERO TELEFÓNICO*"
                          placeholder="(123)-123-1212"
                          v-model="information.phone"
                          v-mask="'(###)-###-####'"
                          type="phone"
                          id="phone"
                        ></v-text-field>
                      </v-col>                      
                    </v-row>
                  </v-card-text>
                  <v-card-actions class="mb-5">
                    <v-layout
                      :row="$vuetify.breakpoint.mdAndUp"
                      :column="$vuetify.breakpoint.smAndDown"
                      :reverse="$vuetify.breakpoint.smAndDown"
                    >
                      <div class="flex-grow-1" v-if="$vuetify.breakpoint.mdAndUp"></div>
                      <v-btn
                        :disabled="loading"
                        rounded
                        :x-large="$vuetify.breakpoint.lgAndUp"
                        text
                        class="px-5"
                        @click="$store.dispatch('agendDate/modalSend', false)"
                      >Cancelar</v-btn>
                      <v-btn
                        :disabled="loading"
                        :loading="loading"
                        rounded
                        :x-large="$vuetify.breakpoint.lgAndUp"
                        color="primary"
                        class="px-5"
                        @click="submitDate()"
                      >Enviar formulario</v-btn>
                    </v-layout>
                  </v-card-actions>
                </v-flex>
              </v-layout>
            </v-card>
          </v-col>
        </v-row>
        <v-snackbar v-model="snackbar" :color="snackbarColor">
          {{ snackbarText }}
          <v-btn color="white" dark text @click="snackbar = false">Cerrar</v-btn>
        </v-snackbar>        
      </v-card>     
    </v-dialog>
    <v-dialog v-model="modalSuccess" max-width="700" persistent>
      <v-card class="mx-auto text-center" style="cursor: pointer">       
        <div
          :class="[
            $vuetify.breakpoint.mdAndUp
              ? 'd-flex justify-end'
              : 'd-flex justify-center',
          ]"
        >
          <v-btn
            text
            style="position: absolute; z-index: 1"
            dark
            large
            icon
            @click="modalSuccess = false"
          >
            <v-icon size="x-large">mdi mdi-close</v-icon>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>    
  </div>
</template>
<style scoped>
.text-wrap {
  word-break: break-word;
}
.input {
  height: 46px;
}
.instructions{
  font-weight: 300;
}
</style>

<script>
import axios from "axios";
import { mapState } from "vuex";
import { mask } from "vue-the-mask";

export default {
  name: "Agendar",
  directives: {
    mask
  },
  data: () => ({
    horarios: [
      "9:00 am - 10:00 am",
      "10:00 am - 11:00 am",
      "11:00 am - 12:00 pm",
      "12:00 pm - 1:00 pm",
      "1:00 pm - 2:00 pm",
      "4:00 pm - 5:00 pm",
      "5:00 pm - 6:00 pm",
      "6:00 pm - 7:00 pm"
    ],    
    inscriptionOptions: [
      "Preescolar",
      "Primaria",
      "Secundaria",
      "Preparatoria",
    ],
    campusSelected: "",
    name: null,
    lastname: null,
    email: null,
    phone: null,
    state: null,
    carrer: null,
    today: new Date().toISOString().substr(0, 10),
    picker: new Date().toISOString().substr(0, 10),
    birthday: new Date().toISOString().substr(0, 10),
    date: null,
    menu: false,
    snackbar: false,
    valid: false,
    modalSuccess: false,
    msg: "",
    snackbarText: "",
    snackbarColor: "",
    color: "",
    loading:false,
    successRecaptcha: false,
    information: {
      name_first: "",
      name_second: "",
      last_name: "",
      mother_last_name: "",
      phone: "",
      email: "",
      campus: "",
      carrer: "",
      horarios: "",
      localidad: "",
      message: "",
      licenciatura: false,
      posgrado: false,
      otros: false,
      escolaridad: "",
      school: "",
      way: ""
    },    
  }),
  methods: {
    changeCity(key) {
      this.$store.dispatch("cities/setCity", key);
      this.campus.forEach(element => {
        if (this.city_selected.toLowerCase() == Object.keys(element)[0]) {
          this.$store.dispatch(
            "cities/setCityOptions2",
            Object.values(element)
          );
        }
      });
    },       
    reCAPTCHAcallback(){
        this.successRecaptcha = true;
    }, 
    allowedDates(val){
      let date = new Date(val)
      return (date.getDay() !== 5 && date.getDay() !== 6);
    },
    validateEmail(email) {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },
    validatePhone(number) {
      let phone = /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/;
      return phone.test(number);
    },    
    validateFieldsDate() {
      if (
        this.information.name_first != "" &&
        this.information.last_name != "" &&
        this.information.mother_last_name != "" &&
        this.information.phone != "" &&
        this.information.email != "" &&
        this.information.campus != "" &&
        this.information.carrer != "" &&
        this.information.horarios != ""
      ) {
        this.valid = true;
      } else {
        this.valid = false;
        this.snackbarText = "Favor de completar todos los campos con asterisco";
        this.snackbar = true;
        this.snackbarColor = "dark";
        return
      }
    },    
    submitDate(){
      this.validateFieldsDate();
      if (this.valid) {
        if (this.validateEmail(this.information.email)) {
          this.emailValid = true;
        } else {
          this.emailValid = false;
          this.snackbarText = "Favor de ingresar un email válido";
          this.snackbar = true;
          return
        }
        if (
          this.validatePhone(this.information.phone) &&
          String(this.information.phone).length == 14
        ) {
          this.phoneValid = true;
        } else {
          this.phoneValid = false;
          this.snackbarText = "Favor de ingresar un número válido";
          this.snackbar = true;
          return
        }
      }else{
        return
      }
      this.loading = true;
      let self = this;
      let formData = new FormData();
      formData.append("firstname", this.information.name_first);
      formData.append("secondname", this.information.name_second);
      formData.append("lastname", this.information.last_name);
      formData.append("lastname1", this.information.mother_last_name);
      formData.append("email", this.information.email);
      formData.append("phone", this.information.phone);
      formData.append("campus", this.information.campus);
      formData.append("carreer", this.information.carrer);
      formData.append("information_by_level", this.information.escolaridad);
      formData.append("webpage", "Colegio");
      formData.append("to_hour", this.information.horarios);
      formData.append("to_date", this.picker);
      axios({
        method: "post",
        url: "https://informesuva.tidingo.com/api/create-cite",
        data: formData,
        config: {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*"
          }
        }
      })
        .then(function(response) {
          if (response.data.status == 200) {
            self.$store.dispatch('agendDate/modalSend', false)
            self.$store.dispatch('agendDate/setSnackbar', {
              color: 'success',
              value: true,
              msg: 'Cita Agendada exitosamente',
            })
            self.modalSuccess = true
          } else {
            self.$store.dispatch('agendDate/modalSend', false)
            self.$store.dispatch('agendDate/setSnackbar', {
              color: 'error',
              value: true,
              msg: 'Ocurrió un error al agendar tu cita, intentalo mas tarde',
            })
          }
          self.clearFields();
          self.loading = false;
        })
        .catch(function(error) {
          self.loading = false;
        });
    },
    clearFields() {
      this.information = {
        name_first: "",
        name_second: "",
        last_name: "",
        mother_last_name: "",
        phone: "",
        email: "",
        campus: "",
        localidad: "",
        message: "",
        licenciatura: false,
        posgrado: false,
        otros: false,
        escolaridad: "",
        horarios: "",
        school: "",
        way: ""
      };
    this.picker = new Date().toISOString().substr(0, 10)
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
  },
  mounted() {
  },  
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.birthday);
    },
    ...mapState({
      modalSend: state => state.agendDate.modalSend,
      city_selected: state => state.cities.city_selected,
      campus: state => state.cities.campus,
      cities: state => state.cities.cities,
    }),    
  },
  watch: {
    campusSelected(val) {
      let sendCity = _.find(this.cities, ["id", val]);
      this.information.campus = sendCity.name;
    }
  } 
};
</script>
